import { Trans, useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { getCurrency } from 'src/services/util';

export default function PaymentReceiptSubscription({ product, isUsed }: { product: CheckoutProductData; isUsed: boolean }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="border-t border-ice-blue">
      <div className="container">
        <div className="mt-8 flex justify-between items-start">
          <div className="N_14_R text-brown-grey">{t('payment/billing_period_title')}</div>
          <div className="N_14_R text-greyish-brown text-right" style={{ maxWidth: '165px' }}>
            {product.durationType && (
              <Trans i18nKey={`payment/billing_period_${product.durationType.toLowerCase()}`} values={{ period: product.duration }}></Trans>
            )}
          </div>
        </div>
        <div className="mt-2 flex justify-between items-center">
          <div className="N_14_R text-brown-grey">{t('payment/service_period_title')}</div>
          <div className="N_14_R text-greyish-brown">
            {product.durationType && (
              <Trans i18nKey={`payment/service_period_${product.durationType.toLowerCase()}`} values={{ period: product.duration }}></Trans>
            )}
          </div>
        </div>
        {!isUsed && product.promotionCycle > 0 && product.promotionAmount > 0 ? (
          <>
            <div className="mt-2 flex justify-between items-center">
              <div className="N_14_R text-brown-grey">
                <Trans i18nKey="payment/cover_price_subscription_title" values={{ promotionCycle: product.promotionCycle + 1 }}></Trans>
              </div>
              <div className="N_14_R text-greyish-brown">
                <NumberFormat value={product.amount} displayType={'text'} thousandSeparator={true} prefix={getCurrency(product.region)} />
              </div>
            </div>
            <div className="mt-2 flex justify-between items-center">
              <div className="N_14_R text-brown-grey">
                <Trans i18nKey="payment/promotion_subscription_title" values={{ promotionCycle: product.promotionCycle }}></Trans>
              </div>
              <div className="N_14_R text-greyish-brown">
                -{' '}
                <NumberFormat
                  value={product.amount - product.promotionAmount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={getCurrency(product.region)}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mt-2 flex justify-between items-center">
              <div className="N_14_R text-brown-grey">{t('payment/cover_price_title')}</div>
              <div className="N_14_R text-greyish-brown">
                <NumberFormat value={product.amount} displayType={'text'} thousandSeparator={true} prefix={getCurrency(product.region)} />
              </div>
            </div>
          </>
        )}
        <div className="border-t mt-6 border-ice-blue"></div>
        <div className="mt-7 mb-11 flex justify-between items-center">
          <div className="N_14_R">
            <span>{t('payment/purchase_amount')}</span>
            <span className="text-brown-grey ml-1">({t('payment/purchase_vat')})</span>
          </div>
          <div className="N_22_M">
            {product.promotionCycle > 0 ? (
              <NumberFormat
                value={isUsed ? product.amount : product.promotionAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={getCurrency(product.region)}
              />
            ) : (
              <NumberFormat value={product.amount} displayType={'text'} thousandSeparator={true} prefix={getCurrency(product.region)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
